import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { Subject } from 'rxjs';

@Component({
  selector: 'wallet-qris-detail',
  templateUrl: './wallet-qris-detail.component.html',
  styleUrls: ['./wallet-qris-detail.component.scss'],
})

export class WalletQrisDetailComponent {
  token: string = '';
  data: any = null;
  token_data: any = null;
  qr_content: string = '';
  lang: string = 'id';
  paymentAmount: number | null = null;
  budgetCategory = {code: '', name: ''};
  isAmountDisabled = true;
  isTransactionValid = false;
  isFieldFocused = false;
//   messages: Message[] | undefined;
  isSessionExpired: boolean = true;
  categories = [];
  currency : string = 'IDR';


  private ngUnsubsribe$ = new Subject<void>();

  @ViewChild('inputNumRef') inputNumRef: any;

  constructor(
    private readonly router: Router,
    private readonly activeRouter: ActivatedRoute,
    public messageService: MessageService,
    private readonly translateService: TranslateService
  ) {
    this.token =
      this.router.getCurrentNavigation()?.extras?.state?.['token'] ?? {};
    this.data =
      this.router.getCurrentNavigation()?.extras?.state?.['data'] ?? {};
    this.qr_content =
      this.router.getCurrentNavigation()?.extras?.state?.['qr_content'] ?? '';
    this.token_data =
      this.router.getCurrentNavigation()?.extras?.state?.['token_data'] ?? {};
    this.paymentAmount = (this.data?.transaction_amount?.value + this.data?.fee_amount?.value) || null;
    this.currency = this.data?.transaction_amount?.currency || 'IDR';
    this.isAmountDisabled = !(!this.paymentAmount);
    this.categories = this.token_data.budget_categories.map(function (i:string) { 
        return {name: i, code: i}});
    this.validateAmount();
    this.activeRouter.queryParamMap.subscribe((params) => {
      this.lang = params.get('lang')!;
    });
  }

  ngOnInit() {
    if (!this.data) {
      this.router.navigate(['']);
    } else {
    //   this.getCardDetail();
    }
  }

  ngAfterViewInit() {
    // Access native input inside p-inputnumber
    const nativeInput: HTMLInputElement | null =
      this.inputNumRef?.el?.nativeElement?.querySelector('input');

    if (nativeInput) {
      nativeInput.addEventListener('paste', this.handlePaste.bind(this));
    }
  }

  onInput(event?: InputNumberInputEvent) {
    if(event) {
      const original = event.value?.toString() || '';
      const digitsOnly = original.replace(/\D/g, '');
      this.paymentAmount = parseInt(digitsOnly || '0', 10);
    }
    this.validateAmount()
  }

  // PASTE HANDLER
  handlePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pasted)) {
      event.preventDefault();
      // escape only digit
      const digitsOnly = pasted.replace(/\D/g, '');
      this.paymentAmount = parseInt(digitsOnly || '0', 10);
      this.validateAmount();
    }
  }

  // VALIDATE IF INPUTTED AMOUNT VALID
  validateAmount(){
    this.isTransactionValid = !this.paymentAmount? false: this.paymentAmount <= this.token_data?.available_balance;
  }

  sanitize($event: any) {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const input = $event.target as HTMLInputElement;
    const raw = input.value;

    // Remove anything that's not a digit
    const digitsOnly = raw.replace(/\D/g, '');
    if (digitsOnly != raw) {
      const parsed = parseInt(digitsOnly, 10);
      this.paymentAmount = isNaN(parsed) ? 0 : parsed;

      $event.target.value = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(this.paymentAmount);
    }

    // Optional: format it back
    this.paymentAmount = parseInt(digitsOnly || '0', 10);
    this.validateAmount();
  }
  

  preventInvalidChars(event: any) {
    const isAndroid = /Android/i.test(navigator.userAgent);
    console.log('keydown event', event);
    const isNumeric = /^\d+$/.test(event.key);
    // prevent invalid chars

    if (!isNumeric || event.key == '.' || event.key == ',') {
      // console.log(previousAmount);
      // this.paymentAmount = previousAmount;
      // event.preventDefault();
      // if(isAndroid) {
      //   this.isFormatInvalid = true;
      // }
      // this.paymentAmount = previousAmount;
    }
    // prevent nul in front
    if (event.key == '0' && !this.paymentAmount) {
      event.preventDefault();
    }
  }

  continueTransaction(){
    this.router.navigate(['trx-pin'], {
      state: {
        token: this.token,
        data: this.generatePaymentPayload(),
        token_data: this.token_data
      },
      queryParams: { lang: this.lang },
      skipLocationChange: true,
    });
  }

  generatePaymentPayload(){
    return {
      amount: {
        value: this.data?.transaction_amount?.value || this.paymentAmount,
        currency: this.data?.transaction_amount?.currency || this.currency
      },
      fee_amount: {
        value: this.data?.fee_amount?.value,
        currency: this.data?.fee_amount?.currency || this.currency
      },
      additional_info: {
        qr_content: this.qr_content
      },
      budget_category: this.budgetCategory.code,
      description: '',
      merchant: {
        name: this.data.merchant_name,
        location: this.data.merchant_location,
        category: this.data.merchant_category,
        postal_code: this.data.merchant_postal_code
      }
    }
  }
}
